import EAlertType from 'enums/EAlertType';
import ESnackBarPosition from 'enums/ESnackBarPosition';
import React, { useContext, useState } from 'react';
import { getCurrentUser, showAlertSnackBar } from 'utils/Global';
import RMSvgIcon from 'components/customComponents/CommonComponents/RMSvgIcon';
import { UserCredentialDTO, UserDTO } from 'business/models/Models';
import UserGroupService from 'business/services/UserGroupService';
import { UserGroupContext } from 'components/main/Licensing/userSetup';
import { cloneDeep } from 'lodash';
import useRockFetchGet from 'utils/RockFetch';

interface Props {
  user: UserDTO;
  onViewOTP: (user: UserDTO) => void;
}

const userService = new UserGroupService();

const GenerateOTPByAdminDialogue = (props: Props) => {
  const [fetchData] = useRockFetchGet();
  const { user, onViewOTP } = props;
  const { setState, setTempState } = useContext(UserGroupContext);
  const [password, setPassword] = useState('');
  const loggedInUser = getCurrentUser();

  const changePassword = (e) => {
    setPassword(e.target.value);
  };

  const fetchUserGroups = () => {
    setTempState((prv) => ({ ...prv, isFetching: true }));
    setState((prv) => ({ ...prv, isFetching: true }));
    Promise.all([
      fetchData('api/user', null, null, true),
      fetchData('api/group?withUsers=true', null, null, true),
      userService.getUserTypes(),
    ]).then(([users, groups, userTypes]) => {
      setTempState((prv) => ({ ...prv, users, groups, userTypes, isFetching: false }));
      setState((prv) => ({
        ...prv,
        users: cloneDeep(users),
        groups: cloneDeep(groups),
        userTypes: cloneDeep(userTypes),
        isFetching: false,
      }));

      const userData = users.find((u) => u.id === getCurrentUser()?.id);
      if (userData) {
        localStorage.setItem('user', JSON.stringify(userData));
      }

      onViewOTP(users.find((u) => u.id === user.id));
    });
  };

  const GenerateOTP = async (e) => {
    e.preventDefault();
    const credentials = new UserCredentialDTO({ userName: user.name, pass: password });
    const response = await userService.validateAdminAndGenerateOTP(credentials);

    if (response) {
      showAlertSnackBar(EAlertType.SUCCESS, ESnackBarPosition.TOP, 'OTP Generated');
      fetchUserGroups();
    } else {
      showAlertSnackBar(EAlertType.ERROR, ESnackBarPosition.TOP, 'Password Incorrect');
    }
  };

  return (
    <form
      id="generateotpbyadmindialogue-form-wrapper"
      className="w-130 mx-auto"
      onSubmit={GenerateOTP}
    >
      <div
        id="generateotpbyadmindialogue-form-warning"
        className="flex flex-row bg-[#FFEDAD]"
      >
        <div
          id="generateotpbyadmindialogue-form-warning-icon"
          className="flex flex-column align-center justify-center ml-2 mr-2"
        >
          <RMSvgIcon name="Warning" width={25} height={25} />
        </div>
        <div
          id="generateotpbyadmindialogue-form-warning-message"
          className="mt-3 mb-3 text-base"
        >
          This action will generate a one time code to reset password.
        </div>
      </div>
      <div
        id="generateotpbyadmindialogue-form-username"
        className="w-full flex flex-column mt-2"
      >
        Enter credentials to proceed.
        <p id="generateotpbyadmindialogue-form-username-text" className="mt-4">
          Username*
        </p>
        <input
          id="generateotpbyadmindialogue-form-username-input"
          className="inputField text-black-100"
          placeholder="Username"
          value={loggedInUser.name}
          disabled={true}
        />
      </div>
      <div
        id="generateotpbyadmindialogue-form-password"
        className="w-full flex flex-column mt-2"
      >
        <p id="generateotpbyadmindialogue-form-password-text">Password*</p>
        <input
          id="generateotpbyadmindialogue-form-password-input"
          className="inputField text-black-100"
          type="password"
          placeholder="Password"
          value={password}
          onChange={changePassword}
        />
      </div>
      <hr id="generateotpbyadmindialogue-form-hr-line" className="bg-gray-500" />
      <div
        id="generateotpbyadmindialogue-form-submit"
        className="w-full flex-x-center mt-2 mb-3 justify-end"
      >
        <button
          id="generateotpbyadmindialogue-form-submit-button"
          className="loginButton w-1/2"
          type="submit"
        >
          <span
            id="generateotpbyadmindialogue-form-submit-button-text"
            className="buttonText"
          >
            GENERATE CODE
          </span>
        </button>
      </div>
    </form>
  );
};

export default GenerateOTPByAdminDialogue;
